import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

import ListingCard from "./ListingCard";

type Props = {
  classes?: Object,
  className?: string,
  listings: Array<Object>,
  officeName: string,
  pdpAction: string,
  title: string,
  scrollX?: boolean, // single-line scrollable listings
  style?: Object,
  withMargin?: boolean, // margin around grid
  zeroContent?: Function | null,
};

const ListingGrid = ({
  classes,
  className,
  listings,
  officeName,
  pdpAction,
  title,
  style,
  zeroContent,
}: Props) => {
  if (!(listings && listings.length) && zeroContent) {
    return zeroContent;
  }

  if (!(listings && listings.length) && !zeroContent) {
    return null;
  }

  const pdpList = listings.map(
    (listing) => `/listings/${listing.detailsUrlSlug}`
  );

  return (
    <div className={classNames(classes.root, className)} style={style}>
      {title && <div className={classes.title}>{title}</div>}
      <div className={classNames(classes.listings)}>
        {listings.map((listing) => {
          return (
            <ListingCard
              key={listing.id}
              className={classes.card}
              listing={listing}
              officeName={officeName}
              pdpAction={pdpAction || "none"}
              pdpList={pdpList}
              compliance={listing.compliance}
            />
          );
        })}
      </div>
    </div>
  );
};

ListingGrid.defaultProps = {
  withMargin: true,
  zeroContent: null,
};

export default withStyles((theme) => ({
  root: {
    display: (props) => (props.scrollX ? "block" : "flex"),
    flexDirection: "column",
    width: (props) => (props.scrollX ? "auto" : "100%"),
    margin: (props) => {
      if (props.scrollX) {
        return "0";
      }
      return props.withMargin ? "48px auto 96px auto" : "0 auto";
    },

    [theme.breakpoints(620)]: {
      maxWidth: "764px",
    },

    [theme.breakpoints(920)]: {
      maxWidth: "1044px",
    },
  },
  title: {
    color: theme.colors.gray["800"],
    fontSize: "18px",
    lineHeight: "1",
    fontWeight: "600",
    textTransform: "uppercase",
    textAlign: "center",
    marginBottom: theme.spacing.unit * 0.25,
  },
  listings: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gridGap: "24px",
    padding: theme.spacing.unit * 0.75,
    justifyItems: "center",

    ".ie-11 &": {
      display: (props) => (props.scrollX ? "inline-flex" : "flex"),
      flexWrap: (props) => (props.scrollX ? "nowrap" : "wrap"),
      justifyContent: "center",
      alignItems: "stretch",
      width: (props) => (props.scrollX ? "auto" : "100%"),
    },
  },
  card: {
    margin: "0px",
    width: "100%",
    maxWidth: "360px",

    ".ie-11 &": {
      margin: "12px 8px",
      width: "auto",
    },
  },
}))(ListingGrid);
